import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DaydicPDF } from 'src/app/shared/models/main/pdf'
import { DdcLoggerService } from '../log/ddc-logger.service'

export interface PdfResponse {
  success: boolean
  message: string
  data?: any // Adjust type as needed based on the response structure
}

export interface GeneratePdfRequest {
  dictionaryId: number
}
export interface PdfsResponse {
  count: number
  next?: string
  previous?: string
  results: DaydicPDF[]
}

@Injectable({
  providedIn: 'root',
})
export class PdfExportService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  generatePDF(args: GeneratePdfRequest): Observable<PdfResponse> {
    return this.http.post<PdfResponse>(`${Backend.HOST_CONTAINER + Backend.PDF}`, args)
  }

  get_PDFs_page(page: number = 1, pageSize: number = 10): Observable<PdfsResponse> {
    this.logger.info(`PDF | get_PDFs_page | page: ${page} | pageSize: ${pageSize}`)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get<{
        results: DaydicPDF[]
        count: number
      }>(`${Backend.HOST_CONTAINER + Backend.PDF}?page=${page}&pageSize=${pageSize}`, httpOptions)
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('PDF | get_PDFs_page | catchError | errorMessage: ' + errorMessage)
          throw error // Re-throw to allow proper error handling
        }),
      )
  }
}
